export default __webpack_public_path__ + "static/footprint_back-611356b08a2881ec0fa4b6d0a4ab4ab0.webp";